import React, { useEffect, useState, useCallback } from 'react';
import { Guitar, Check } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AdminRepechage() {
  const [entries, setEntries] = useState([]);

  const load = useCallback(() => api.get('/public/repechage').then((r) => setEntries(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const classify = async (band_id) => {
    try {
      await api.post(`/admin/repechage/classify/${band_id}`);
      toast.success('Banda classificada para repescagem');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro');
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <div className="font-display text-4xl text-white">REPESCAGEM</div>
        <p className="text-muted-foreground">Ranking dos segundos lugares por percentual de votos.</p>
      </div>
      {entries.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-muted-foreground">Nenhuma etapa finalizada ainda.</CardContent></Card>
      ) : (
        <Card className="border border-border bg-card">
          <CardContent className="p-0">
            <ul className="divide-y divide-border">
              {entries.map((e, i) => (
                <li key={`${e.stage_slug || 'stage'}-${e.band?.id || e.band?.slug || i}`} className="p-4 flex items-center gap-4">
                  <div className="w-10 text-center font-display text-3xl text-[var(--g66-amber)]">{i + 1}</div>
                  <div className="w-12 h-12 rounded-lg bg-[#0b0c0f] flex items-center justify-center border border-border overflow-hidden">
                    {e.band?.logo_url ? <img src={e.band.logo_url} alt={e.band.name} className="w-full h-full object-cover" /> : <Guitar className="w-5 h-5 text-muted-foreground" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-white">{e.band?.name}</div>
                    <div className="text-xs text-muted-foreground truncate">Perdeu em: {e.stage_title}</div>
                  </div>
                  <div className="text-right mr-3">
                    <div className="font-display text-2xl text-white">{e.loser_percentage?.toFixed?.(1) || 0}%</div>
                    <div className="text-xs text-muted-foreground">{e.loser_votes} votos</div>
                  </div>
                  <Button size="sm" onClick={() => classify(e.band?.id)} className="bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]" data-testid={`classify-band-${e.band?.slug}`}>
                    <Check className="w-4 h-4 mr-1" /> Classificar
                  </Button>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
